import { useEffect, useState } from "react";
import { getAdminHeaders } from "./adminApi";

const empty = {
  week_label: "",
  published_count: 0,
  new_url_count: 0,
  submitted_count: 0,
  crawled_count: 0,
  index_count: 0,
  impressions: 0,
  clicks: 0,
  queries: "",
  errors: "",
  fixes: "",
  note: "数据来自百度搜索资源平台手工抄录，提交成功不等于已被收录。",
};

const fields = [
  ["published_count", "本周新公开文章"],
  ["new_url_count", "新增公开 URL"],
  ["submitted_count", "已提交 URL"],
  ["crawled_count", "抓取成功 URL"],
  ["index_count", "百度索引量"],
  ["impressions", "展现量"],
  ["clicks", "点击量"],
];

export default function AdminSeoLog() {
  const [form, setForm] = useState(empty);
  const [items, setItems] = useState([]);
  const [message, setMessage] = useState("");

  const load = async () => {
    const res = await fetch("/api/admin/growth/seo-logs", { headers: getAdminHeaders() });
    const data = await res.json();
    if (res.ok) setItems(data.items || []);
  };

  useEffect(() => {
    load();
  }, []);

  const save = async (event) => {
    event.preventDefault();
    const payload = { ...form };
    fields.forEach(([key]) => {
      payload[key] = Number(form[key] || 0);
    });
    const res = await fetch("/api/admin/growth/seo-logs", {
      method: "POST",
      headers: getAdminHeaders(true),
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) {
      setMessage(data.detail || "保存失败");
      return;
    }
    setMessage("已记录。索引量请填写百度后台数字，不要填写 site: 搜索条数。");
    setForm(empty);
    load();
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold">百度收录周记</h2>
        <p className="text-sm text-gray-500 mt-1">每周手工记录。没有自动读取百度后台。</p>
      </div>
      <form onSubmit={save} className="bg-white rounded-2xl shadow p-6 space-y-4">
        <label className="block text-sm">
          统计周
          <input className="mt-1 w-full border rounded-xl px-3 py-2" placeholder="2026-10-13" value={form.week_label} onChange={(e) => setForm({ ...form, week_label: e.target.value })} required />
        </label>
        <div className="grid md:grid-cols-3 gap-3">
          {fields.map(([key, label]) => (
            <label key={key} className="block text-sm">
              {label}
              <input type="number" min="0" className="mt-1 w-full border rounded-xl px-3 py-2" value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
            </label>
          ))}
        </div>
        <label className="block text-sm">主要搜索词<textarea className="mt-1 w-full border rounded-xl px-3 py-2 h-16" value={form.queries} onChange={(e) => setForm({ ...form, queries: e.target.value })} /></label>
        <label className="block text-sm">技术错误<textarea className="mt-1 w-full border rounded-xl px-3 py-2 h-16" value={form.errors} onChange={(e) => setForm({ ...form, errors: e.target.value })} /></label>
        <label className="block text-sm">本周修复<textarea className="mt-1 w-full border rounded-xl px-3 py-2 h-16" value={form.fixes} onChange={(e) => setForm({ ...form, fixes: e.target.value })} /></label>
        <label className="block text-sm">备注<textarea className="mt-1 w-full border rounded-xl px-3 py-2 h-16" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} /></label>
        <button className="px-4 py-2 rounded-xl bg-gray-800 text-white" type="submit">保存本周记录</button>
        {message ? <p className="text-sm text-rose-700">{message}</p> : null}
      </form>
      <div className="bg-white rounded-2xl shadow divide-y">
        {items.length === 0 ? <p className="p-6 text-gray-400">还没有记录</p> : null}
        {items.map((item) => (
          <div key={item.id} className="p-4 text-sm space-y-1">
            <p className="font-medium">{item.week_label} · 记录于 {item.recorded_at}</p>
            <p>公开文章 {item.published_count} · 新 URL {item.new_url_count} · 已提交 {item.submitted_count} · 抓取 {item.crawled_count}</p>
            <p>索引量 {item.index_count} · 展现 {item.impressions} · 点击 {item.clicks}</p>
            {item.queries ? <p>搜索词：{item.queries}</p> : null}
            {item.errors ? <p>错误：{item.errors}</p> : null}
            {item.fixes ? <p>修复：{item.fixes}</p> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
